import axios from "axios";

export const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
export const SERVER_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const resolveImage = (path) => {
  if (!path) return path;
  if (path.startsWith("/uploads/")) return `${SERVER_ORIGIN}${path}`;
  return path;
};

export default api;
